<script setup>
import { OrganizationSchema } from '~/schemas/Organization';

useSeoMeta({
  ogUrl: "https://navatel.ir/about-us/",
  ogTitle: "درباره نواتل | پیشرو در ارائه راهکارهای ابری",
  ogDescription: "نواتل، شرکت پیشرو ایرانی در حوزه ارتباطات ابری، با بهره‌گیری از فناوری‌های روز دنیا، خدمات ارتباطی یکپارچه و پیشرفته را به کسب‌وکارها ارائه می‌دهد.",
})

useHead({
  title: "درباره نواتل | پیشرو در ارائه راهکارهای ابری",
  meta: [
    {
      name: 'description',
      content: 'نواتل، شرکت پیشرو ایرانی در حوزه ارتباطات ابری، با بهره‌گیری از فناوری‌های روز دنیا، خدمات ارتباطی یکپارچه و پیشرفته را به کسب‌وکارها ارائه می‌دهد.'
    }
  ],
  link: [
    {
      rel: "canonical",
      href: "https://navatel.ir/about-us/",
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      textContent: JSON.stringify(OrganizationSchema)
    },
  ],
});

const topCardDetails = {
  title: "نواتل، نسل نوین ارتباط",
  desc: 'سال ۱۳۸۰ شرکت دانش بنیان "شبکه گستران آریا سامانه" فعالیت خود را با تمرکز بر ارائه‌ خدمات اینترنت و تلفن بین‌الملل آغاز کرد. آریا سامانه یکی از پیشگامان ارائه‌ خدمات ارتباطی و تلفن اینترنتی ویپ (VoIP) در ایران است. این شرکت از سال ۱۳۹۳ با استفاده از توانمندی‌های فنی و اجرایی خود و البته توجه به نیاز بازار، ساخت سوپر اپلیکیشن مالتی پلتفرم "شبکه هوشمند نوا" را در دستور کار خود قرار داد و سال 1397 توانست نخستین سرویس ارتباط یکپارچه ابری را برای کسب‌و‌کارها (UCaaS) با برند "نواتل" در ایران عرضه کند. در دی‌ماه سال ۱۳۹۹ نواتل به عنوان اولین سرویس حوزه UCaaS بر بستر نوا وارد بازار شد و مورد استقبال کسب‌وکارها قرار گرفت.',
  img: "/img/about-us/main.webp",
};
const firstColoredCardData = {
  title: "بیانیه مأمــــوریت",
  subtitle: "Our Mission",
  desc: "آینده ارتباطات تجاری با نواتل انعطاف‌پذیرتر، هوشمندتر و شخصی‌‌تر خواهد شد.",
};
const secondColoredCardData = {
  title: "چشــــــــــــم‌انداز",
  subtitle: "Our Vision",
  desc: "ما در نواتل سعی بر این داریم تا شما عزیزان بتوانید با کمترین هزینه به بالاترین امکانات در زمینه یکپارچه‌سازی ارتباطات در هر مکانی از این ایران زیبا برسید. ",
};
const baseDescData = {
  title: "ارزش‌های سازمانی",
  desc: "یکی از اهداف مهم نواتل، کسب تجارب بهتر برای مشتریان و تمام کارکنان خود است. نواتل توانسته طی این سالیان با پایبندی به اصول نام برده شده، در کنار رشد و توسعه، امانتدار اعتماد مشتریان و همراهانش باشد:",
  features: [
    { id: 1, text: "توجه به نظرات و انتقادات مشتریان" },
    { id: 2, text: "ایمنی، رفاه و کیفیت زندگی پرسنل" },
    { id: 3, text: "حفظ و توسعه منافع سهامداران و پرسنل" },
    { id: 4, text: "کسب و تولید دانش" },
    { id: 5, text: "خلاقیت" },
    { id: 6, text: "مسئولیت‌پذیری" },
    { id: 7, text: "چابکی و بهبود مستمر" },
  ],
};

const details = {
  title: "مدیر عامل نواتل",
  desc: "حمید فروزنده مدیرعامل و رییس هیات مدیره نواتل حمید فروزنده کارآفرین و نوآور در حوزه اینترنت، مخابرات و فناوری اطلاعات و فارغ التحصیل کارشناسی در رشته مهندسی نرم افزار از دانشگاه شهید بهشتی و کارشناسی ارشد مدیریت کسب و کار از دانشگاه منچستر است.حمید فروزنده با بیش از بیست و شش سال سابقه فعالیت و معرفی محصولات نوآورانه مختلف، مرکز تلفن و مرکز تماس ابری نواتل را به عنوان اولین محصولات دانش بنیان این حوزه با اپلیکیشن اختصاصی روانه بازار کرده است.هم اکنون نواتل  با بیش از 100 نیروی متخصص به عنوان تنها شرکت تخصصی در حوزه مرکز تلفن ابری و مرکز تماس ابری با اپلیکیشن اختصاصی، سهم بالایی از بازار داخلی را  به خود اختصاص داده است.",
};
</script>

<template>
  <div>
    <BaseTopCard :details="topCardDetails" isWhiteBg />
    <BaseColoredCard :data="firstColoredCardData" isDarkBlueBg />
    <HomeLicenses isAlwaysShow tag="h2" />
    <BaseColoredCard :data="secondColoredCardData" isBlueBg />
    <BaseDescription :data="baseDescData" important />
  </div>
</template>
